import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import StateOverview from "../components/child/StateOverview";
const StateOverviewPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout >

        {/* Breadcrumb */}
        <Breadcrumb title="State Overview" />

        <StateOverview />

      </MasterLayout>
    </>
  );
};

export default StateOverviewPage;
